import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { LANGUAGES } from '../../../config/consts';
import actions from '../../../modules/cookies';
import { useAppContext } from '../../App/AppContextProvider';

export function useLoginFlowsWrapper() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { currentUserLang } = useAppContext();
  const yearTo = new Date().getFullYear().toString();

  useEffect(() => {
    dispatch(actions.setGlobalCookieSettingsIconShown(false));
    return () => {
      dispatch(actions.setGlobalCookieSettingsIconShown(true));
    };
  }, []);

  const links2nMap = {
    [LANGUAGES.czech.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.german.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.english.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.spanish.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.french.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.italian.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.dutch.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
    [LANGUAGES.finnish.locale]: 'https://portal.productboard.com/uef9lw6yumoa4gcpd53z34px',
  };

  return {
    currentUserLang,
    dispatch,
    formatMessage,
    link2N: links2nMap[currentUserLang!],
    yearTo,
  };
}
